import { render, staticRenderFns } from "./tempo_bloqueio_certificado.vue?vue&type=template&id=393785a6&"
import script from "./tempo_bloqueio_certificado.vue?vue&type=script&lang=js&"
export * from "./tempo_bloqueio_certificado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports